import {getBlackbirdExperiments, setBlackbirdExperiments} from '@github-ui/blackbird-experiments'
import {Link, Portal, TextInput} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import {useState} from 'react'

import styles from './ExperimentsDialog.module.css'

const experimentsQuery = 'repo:github/blackbird-mw "var StaffEnabled = Experiments"'

export const ExperimentsDialog = ({
  onDismiss,
  onSave,
}: {
  onDismiss: () => void
  onSave: () => void
}): React.ReactElement => {
  const [experiments, setExperiments] = useState(() => getBlackbirdExperiments().join(','))
  const [statusMessage, setStatusMessage] = useState<string | undefined>(undefined)
  const saveExperiments = () => {
    const experimentsArray = []
    for (const pair of experiments.split(',')) {
      if (pair.trim() === '') continue

      if (pair.split('=').length !== 2) {
        setStatusMessage('Invalid experiment key=value pair')
        return
      }
      experimentsArray.push(pair)
    }

    setBlackbirdExperiments(experimentsArray)
    onSave()
    onDismiss()
  }

  return (
    <Portal>
      <Dialog onClose={onDismiss} title={'Experiments'} width="xlarge">
        <Dialog.Body>
          <div className={styles.dialogBody}>
            <span>
              List experiments as comma separated <code>key=value</code> pairs. To see available experiments,{' '}
              <Link inline target="_blank" href={`/search?q=${encodeURIComponent(experimentsQuery)}`}>
                read this code
              </Link>
              .
            </span>
            <TextInput
              className={styles.experimentsInput}
              aria-label="Experiments"
              name="experiments"
              value={experiments}
              onChange={e => setExperiments(e.target.value)}
              onKeyDown={e => {
                // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
                if (e.key === 'Enter') {
                  saveExperiments()
                }
              }}
            />
            <span>{statusMessage}</span>
          </div>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Buttons
            buttons={[
              {type: 'button', onClick: onDismiss, content: 'Cancel'},
              {type: 'submit', onClick: saveExperiments, content: 'Save', buttonType: 'primary'},
            ]}
          />
        </Dialog.Footer>
      </Dialog>
    </Portal>
  )
}
